/*****
 * injected into header.php so can use in modules like blocks/interactive-map.php
 *****/

// Get an element's distance from the top of the page
// from https://gomakethings.com/get-distances-to-the-top-of-the-document-with-native-javascript/
site.getElemDistance = function (elem) {
  var location = 0;
  if (elem.offsetParent) {
    do {
      location += elem.offsetTop;
      elem = elem.offsetParent;
    } while (elem);
  }
  return location >= 0 ? location : 0;
};

// no jquery for this, from https://stackoverflow.com/a/1038781/4504073
site.getWidth = function () {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
};

site.getHeight = function () {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  );
};
